import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class MessageTaskPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:SendTask' || elementType === 'epx:ReceiveTask';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'messageTask',
        label: i18n.messageTask || 'Message',
        entries: [
          {
            id: 'messageRef',
            component: () => (
              <TextFieldEntry
                id="epx-message-ref"
                label={i18n.messageRef || 'Message Ref'}
                value={props.messageRef || ''}
                onChange={(val) => update('messageRef', val)}
              />
            ),
          },
          {
            id: 'operationRef',
            component: () => (
              <TextFieldEntry
                id="epx-operation-ref"
                label={i18n.operationRef || 'Operation Ref'}
                value={props.operationRef || ''}
                onChange={(val) => update('operationRef', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
